export const UUID_AND_NUMERIC_REGEXP =
  /[^\/]*[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}[^\/]*|\b\d+\b/g;
export const LONG_STRING_REGEXP = /\/([^\/]{31,})/g;
